import React from 'react';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {classes} from './CouponTag.st.css';
import {SkeletonLineWrapper} from '../../../../../common/components/Skeleton/SkeletonLineWrapper/SkeletonLineWrapper';

export enum CouponTagDataHook {
  CouponTagText = 'CouponTag.Text',
  CouponTagSkeleton = 'CouponTag.Skeleton',
}

export const CouponTag = () => {
  const localeKeys = useLocaleKeys();
  const {cart, cartSummary, isCartSummaryUpdating} = useControllerProps().checkoutStore;
  const shouldShowTag = cart.hasItemWithCouponDiscount;

  if (!shouldShowTag) {
    return null;
  }

  const getTagText = () => {
    const targetLineItemIds = cartSummary?.couponDiscount?.targetLineItemIds;
    return targetLineItemIds?.length === 1
      ? localeKeys.checkout.couponField.savedOnItem({
          amountOff: cartSummary?.couponDiscount?.totalAmountOff,
          itemName: cart.lineItems.find((lineItem) => lineItem.id === targetLineItemIds[0])?.name,
        })
      : localeKeys.checkout.couponField.savedOnItems({
          amountOff: cartSummary?.couponDiscount?.totalAmountOff,
          totalItems: targetLineItemIds?.length,
        });
  };

  return isCartSummaryUpdating || !cartSummary ? (
    <SkeletonLineWrapper dataHook={CouponTagDataHook.CouponTagSkeleton} size="large" />
  ) : (
    <Text data-hook={CouponTagDataHook.CouponTagText} className={classes.text}>
      {getTagText()}
    </Text>
  );
};
